import TaskRow from './TaskRow'
import CommentsNumberContainer from '../../../taskManagement/components/CommentsNumberContainer'
import {unsafe_selectWithState} from '../../../redux/utils'
import WorkflowStatusIcon from '../../../workflowStatus/WorkflowStatusIcon'
import {selectStatusByTask} from '../../../workflowStatus/selectors'
import ViewTTStore from '../ViewTTStore'
import CustomerStore from '../../../store/CustomerStore'
import ProjectStore from '../../../store/ProjectStore'
import TruncatedTextView from '../../../TruncatedTextView'

export default class ViewByDaysTaskRow extends TaskRow
{
    constructor({
        dayModel = null,
        taskModel = null,
        last = false,
    } = {})
    {
        super({taskModel, last})

        this.params = {
            ...this.params,
            dayModel,
        }
    }

    templateHtml()
    {
        return "<tr class='taskRow'>" +
               "  <td class='nameColumn'>" +
               "    <div class='subContainer'>" +
               "      <div class='iconNameContainer'>" +
               "        <div class='iconContainer'></div>" +
               "        <div class='name'><%-name%></div>" +
               "        <div class='subtitle'><%-customerName%> / <%-projectName%></div>" +
               "      </div>" +
               "      <div class='commentsNumberPlaceholder'></div>" +
               "    </div>" +
               "  </td>" +
               "  <td class='totalColumn'><div class='subContainer'><%-total%></div></td>" +
               "  <td class='detailsColumn'><div class='subContainer'></div></td>" +
               "</tr>"
    }

    afterRender()
    {
        super.afterRender()

        const task = ViewTTStore.getTask(this.params.taskModel.taskId);
        new WorkflowStatusIcon(this.find(".iconContainer"), unsafe_selectWithState(state => selectStatusByTask(state, task))).init();
        this.$el.toggleClass("locked", this.params.dayModel.locked);
        this.$el.toggleClass("nonWorking", this.params.dayModel.workdayDuration === 0);

        this.commentsNumber = new CommentsNumberContainer().init(this.find('.commentsNumberPlaceholder'))
        this.commentsNumber.setState({
            commentsNumber: task.commentsNumber
        })

        new TruncatedTextView({text: this.params.taskModel.comment, lineCount: 5}).init(this.find('.detailsColumn > .subContainer'))
    }

    templateModel()
    {
        const task = ViewTTStore.getTask(this.params.taskModel.taskId)
        return {
            name: task.name,
            customerName: ViewTTStore.getCustomer(task.customerId).name,
            projectName: ViewTTStore.getProject(task.projectId).name,
            total: UserTime.formatTimeWithDigitSeparator(this.params.taskModel.spent),
        }
    }
}


// WEBPACK FOOTER //
// ./web/js/user/viewtt/detailsTable/ViewByDaysTaskRow.js